import t from "../common/localization";
import React from "react";
import { useSelector } from "react-redux";
import { useAttributePreference } from "../common/preferences";
import {
  formatDistance,
  formatHours,
  formatDate,
  formatSpeed,
  formatVolume,
  formatPosition,
  formatDurationTime,
} from "../common/formatter";
import FaceIcon from "@material-ui/icons/Face";
import FavoriteIcon from "@material-ui/icons/Favorite";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import Divider from "@material-ui/core/Divider";
import SpeedIcon from "@material-ui/icons/Speed";
import Chip from "@material-ui/core/Chip";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import BatteryStdIcon from "@material-ui/icons/BatteryStd";
import NavigationIcon from "@material-ui/icons/Navigation";
import AcUnitIcon from "@material-ui/icons/AcUnit";
import LocalGasStationIcon from "@material-ui/icons/LocalGasStation";
import { Grid, Paper, List, ListItem } from "@material-ui/core";
import { isWidthUp, makeStyles, withWidth } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    borderRadius: 15,
    // backgroundColor: "#F1F3F6",
    fontSize: 12,
    height: "600px",
  },
  row: {
    height: "auto",
  },
  list: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  listItem: {
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  colP: {
    margin: "0",
        textAlign: "center",
        fontSize: "8px",
  }
}));

const StatusView = ({ deviceId, onShowDetails }) => {
  const device = useSelector((state) => state.devices.items[deviceId]);
  const position = useSelector((state) => state.positions.items[deviceId]);

  const distanceUnit = useAttributePreference("distanceUnit");
  const speedUnit = useAttributePreference("speedUnit");
  const volumeUnit = useAttributePreference("volumeUnit");

  const handleClick = (e) => {
    e.preventDefault();
    onShowDetails(position.id);
  };
  const classes = useStyles();

  return (
    <>
      <div
        className={classes.root}
        // style={{
        //   borderRadius: 15,
        //   backgroundColor: "#F1F3F6",
        //   fontSize: 12,
        //   boxShadow: "2px 2px 2px 2px #dbddef",
        // }}
      >
        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Grid container spacing={3}>
              <Grid item xs={3} alignItems="center">
                {/* <Paper className={classes.paper}> */}
                <p className={classes.colP}>
                  {<SpeedIcon style={{ color: "#6C6C6C", fontSize: "18", position: "center", horizontalAlign: "middle" }} />}
                </p>
                <p
                  className={classes.colP}
                  style={{ color: "#6C6C6C", fontSize: "6" }}
                >
                  {formatSpeed(position.speed, speedUnit)}
                </p>
                <p className={classes.colP}>
                  <b>{t("positionSpeed")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>
                <p className={classes.colP}>
                  {
                    <NavigationIcon
                      style={{ color: "#853AE5", fontSize: "20" }}
                    />
                  }
                </p>
                <p className={classes.colP}>
                  {formatDistance(
                    position.attributes.todayDistance,
                    distanceUnit
                  )}
                </p>
                <p className={classes.colP}>
                  <b>{t("distance")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>
                <p className={classes.colP}>
                  {
                    <BatteryStdIcon
                      style={{ color: "#00D3A5", fontSize: "20" }}
                    />
                  }
                </p>
                <p className={classes.colP}>
                  {formatPosition(
                    position.attributes.batteryLevel,
                    "batteryLevel"
                  )}
                </p>
                <p className={classes.colP}>
                  <b>{t("positionBattery")}:</b>
                </p>
              </Grid>
            </Grid>
          </ListItem>
        </List>


        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                {/* <Paper className={classes.paper}> */}

                <p
                  className={classes.colP}
                  style={{ color: "#6C6C6C", fontSize: "6" }}
                >
                  {formatDate(position.fixTime, "LLL")}
                </p>
                <p className={classes.colP}>
                  <b>{t("positionFixTime")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>

                <p className={classes.colP}>
                  {formatDistance(
                    position.attributes.totalDistance,
                   distanceUnit
                  )}
                </p>
                <p className={classes.colP}>
                  <b>{t("deviceTotalDistance")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>
                <p className={classes.colP}>
                  {formatVolume(position.attributes.todayFuel, "40"
                  )}
                </p>
                <p className={classes.colP}>
                  <b>{t("todayFuel")}:</b>
                </p>
              </Grid>
            </Grid>
          </ListItem>
        </List>

        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                {/* <Paper className={classes.paper}> */}

                <p
                  className={classes.colP}
                  style={{ color: "#6C6C6C", fontSize: "6" }}
                >
                  {formatDurationTime(position.attributes.todayRunningTime)}
                </p>
                <p className={classes.colP}>
                  <b>{t("todayRunningTime")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>

                <p className={classes.colP}>
                  {formatDurationTime(position.attributes.todayStoppedTime
                  )}
                </p>
                <p className={classes.colP}>
                  <b>{t("todayStoppedTime")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>
                <p className={classes.colP}>
                  {formatDurationTime(position.attributes.todayIdleTime
                  )}
                </p>
                <p className={classes.colP}>
                  <b>{t("todayIdleTime")}:</b>
                </p>
              </Grid>
            </Grid>
          </ListItem>
        </List>

        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                {/* <Paper className={classes.paper}> */}

                <p
                  className={classes.colP}
                  style={{ color: "#6C6C6C", fontSize: "6" }}
                >
                  {formatPosition(
                    position.attributes.currentStatus,
                    "currentStatus")}
                </p>
                <p className={classes.colP}>
                  <b>{t("currentStatus")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>

                <p className={classes.colP}>
                  {formatSpeed(position.attributes.todayMaxSpeed, speedUnit)}
                </p>
                <p className={classes.colP}>
                  <b>{t("todayMaxSpeed")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>
                <p className={classes.colP}>
                  {formatDistance(
                  position.attributes.distanceFromLastStop,
                   distanceUnit
                   )}
                </p>
                <p className={classes.colP}>
                  <b>{t("distanceFromLastStop")}:</b>
                </p>
              </Grid>
            </Grid>
          </ListItem>
        </List>

        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                {/* <Paper className={classes.paper}> */}

                <p
                  className={classes.colP}
                  style={{ color: "#6C6C6C", fontSize: "6" }}
                >
                  {formatDurationTime(
                  position.attributes.todayIgnitionOnTime)}
                </p>
                <p className={classes.colP}>
                  <b>{t("todayIgnitionOnTime")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>

                <p className={classes.colP}>
                  {formatDurationTime(
                    position.attributes.todayIgnitionOffTime)}
                </p>
                <p className={classes.colP}>
                  <b>{t("todayIgnitionOffTime")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>
                <p className={classes.colP}>
                  {formatDurationTime(position.attributes.ignitionOnSince)}
                </p>
                <p className={classes.colP}>
                  <b>{t("ignitionOnSince")}:</b>
                </p>
              </Grid>
             <Grid item xs={3}>
                <p className={classes.colP}>
                  {formatDurationTime(position.attributes.ignitionOffSince)}
                </p>
                <p className={classes.colP}>
                  <b>{t("ignitionOffSince")}:</b>
                </p>
              </Grid>
            </Grid>
          </ListItem>
        </List>

        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                {/* <Paper className={classes.paper}> */}

                <p
                  className={classes.colP}
                  style={{ color: "#6C6C6C", fontSize: "6" }}
                >
                  {formatDurationTime(position.attributes.todayAcOnTime)}
                </p>
                <p className={classes.colP}>
                  <b>{t("todayAcOnTime")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>

                <p className={classes.colP}>
                  {formatDurationTime(position.attributes.todayAcOffTime)}
                </p>
                <p className={classes.colP}>
                  <b>{t("todayAcOffTime")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>
                <p className={classes.colP}>
                  {formatDurationTime(position.attributes.acOnSince)}
                </p>
                <p className={classes.colP}>
                  <b>{t("acOnSince")}:</b>
                </p>
              </Grid>
             <Grid item xs={3}>
                <p className={classes.colP}>
                  {formatDurationTime(position.attributes.acOffSince)}
                </p>
                <p className={classes.colP}>
                  <b>{t("acOffSince")}:</b>
                </p>
              </Grid>
            </Grid>
          </ListItem>
        </List>

        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                {/* <Paper className={classes.paper}> */}

                <p
                  className={classes.colP}
                  style={{ color: "#6C6C6C", fontSize: "6" }}
                >
                  {formatVolume(position.attributes.todayMileageConsumedFuel)}
                </p>
                <p className={classes.colP}>
                  <b>{t("todayMileageConsumedFuel")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>

                <p className={classes.colP}>
                  {formatVolume(position.attributes.totalMileageConsumedFuel)}
                </p>
                <p className={classes.colP}>
                  <b>{t("totalMileageConsumedFuel")}:</b>
                </p>
              </Grid>
              <Grid item xs={3}>
                <p className={classes.colP}>
                  {formatPosition(position.attributes.mtCustom1, "mtCustom1")}
                </p>
                <p className={classes.colP}>
                  <b>{t("mtCustom1")}:</b>
                </p>
              </Grid>
             <Grid item xs={3}>
                <p className={classes.colP}>
                  {formatPosition(position.attributes.mtCustom2, "mtCustom2")}
                </p>
                <p className={classes.colP}>
                  <b>{t("mtCustom2")}:</b>
                </p>
              </Grid>
            </Grid>
          </ListItem>
        </List>
        {/*


              {position.attributes.todayIgnitionOnTime && (``
                <TableCell className={classes.tableCell}>
                  <p>
                    {formatDurationTime(
                      position.attributes.todayIgnitionOnTime
                    )}
                    <br />
                  </p>
                  <p>
                    <b>{t("todayIgnitionOnTime")}:</b>
                  </p>
                </TableCell>
              )}
              {position.attributes.todayIgnitionOffTime && (
                <TableCell className={classes.tableCell}>
                  <p>
                    {formatDurationTime(
                      position.attributes.todayIgnitionOffTime
                    )}
                    <br />
                  </p>
                  <p>
                    <b>{t("todayIgnitionOffTime")}:</b>
                  </p>
                </TableCell>
              )}
              {position.attributes.ignitionOnSince &&
                position.attributes.ignitionOnSince !== 0 && (
                  <TableCell className={classes.tableCell}>
                    <p>
                      {formatDurationTime(position.attributes.ignitionOnSince)}
                      <br />
                    </p>
                    <p>
                      <b>{t("ignitionOnSince")}:</b>
                    </p>
                  </TableCell>
                )}
              {position.attributes.ignitionOffSince &&
                position.attributes.ignitionOffSince !== 0 && (
                  <TableCell className={classes.tableCell}>
                    <p>
                      {formatDurationTime(position.attributes.ignitionOffSince)}
                      <br />
                    </p>
                    <p>
                      <b>{t("ignitionOffSince")}:</b>
                    </p>
                  </TableCell>
                )}
            </TableRow>
          </Table>
        </TableContainer> */}

        <b>{t("positionAddress")}:</b>{" "}
        {formatPosition(position.address, "address")}
        <br />

        {position.attributes.todayAcOnTime && (
          <>
            <b>{t("todayAcOnTime")}:</b>{" "}
            {formatDurationTime(position.attributes.todayAcOnTime)}
            <br />
          </>
        )}
        {<AcUnitIcon style={{ color: "#2A74BD" }} />}
        {position.attributes.todayAcOffTime && (
          <>
            <b>{t("todayAcOffTime")}:</b>{" "}
            {formatDurationTime(position.attributes.todayAcOffTime)}
            <br />
          </>
        )}
        {<LocalGasStationIcon style={{ color: "#6C6C6C" }} />}
        {position.attributes.todayFuel && (
          <>
            <b>{t("todayFuel")}:</b>{" "}
            {formatVolume(position.attributes.todayFuel)}
            <br />
          </>
        )}
        {position.attributes.todayMileageConsumedFuel && (
          <>
            <b>{t("todayMileageConsumedFuel")}:</b>{" "}
            {formatVolume(position.attributes.todayMileageConsumedFuel)}
            <br />
          </>
        )}
        {position.attributes.totalMileageConsumedFuel && (
          <>
            <b>{t("totalMileageConsumedFuel")}:</b>{" "}
            {formatVolume(position.attributes.totalMileageConsumedFuel)}
            <br />
          </>
        )}
        {position.attributes.ignitionOnSince &&
          position.attributes.ignitionOnSince !== 0 && (
            <>
              <b>{t("ignitionOnSince")}:</b>{" "}
              {formatDurationTime(position.attributes.ignitionOnSince)}
              <br />
            </>
          )}
        {position.attributes.ignitionOffSince &&
          position.attributes.ignitionOffSince !== 0 && (
            <>
              <b>{t("ignitionOffSince")}:</b>{" "}
              {formatDurationTime(position.attributes.ignitionOffSince)}
              <br />
            </>
          )}
        {position.attributes.acOnSince && position.attributes.acOnSince !== 0 && (
          <>
            <b>{t("acOnSince")}:</b>{" "}
            {formatDurationTime(position.attributes.acOnSince)}
            <br />
          </>
        )}
        {position.attributes.acOffSince &&
          position.attributes.acOffSince !== 0 && (
            <>
              <b>{t("acOffSince")}:</b>{" "}
              {formatDurationTime(position.attributes.acOffSince)}
              <br />
            </>
          )}
        {position.attributes.mtCustom1 && (
          <>
            <b>{t("mtCustom1")}:</b>{" "}
            {formatPosition(position.attributes.mtCustom1, "mtCustom1")}
            <br />
          </>
        )}
        {position.attributes.mtCustom2 && (
          <>
            <b>{t("mtCustom2")}:</b>{" "}
            {formatPosition(position.attributes.mtCustom2, "mtCustom2")}
            <br />
          </>
        )}
      </div>
    </>
  );
};

export default StatusView;
